import { syncClientUser } from '../client-user'
import { syncDrafts } from '../draft'
import { syncPrivateSpace } from '../private-space'
import { syncPv } from '../pv'
import { syncRooms } from '../room'
import { syncSubscription } from '../subscription'
import { syncUserPreferences } from '../user-preferences'
import { syncWappRoom } from '../wapp-room'
import { syncWapps } from '../wapps/service'
import { syncMessages } from '$logic/message'
import { callService } from '$logic/call'
import { syncSeen } from '$logic/room-seen'
import { syncContacts } from '$logic/contacts/service'
import { syncMentionSeen } from '$logic/mention'
import { syncInvitationInfo } from '$logic/invite/service'
import { syncRoomsLastMessages } from '$logic/room-last-message'
import { syncStoryRibbons } from '$logic/story/service'
import { syncUserProfile } from '../profile'
import { syncAds } from '$logic/ads/service'
import { syncWorkspaces } from '$logic/workspace'

export const immediateSyncFuncs = [syncRooms]

export const delayedSyncFuncs = [
  syncWorkspaces,
  syncMessages,
  syncPrivateSpace,
  syncSubscription,
  syncDrafts,
  syncClientUser,
  syncPv,
  syncSeen,
  syncUserPreferences,
  syncWappRoom,
  syncContacts,
  syncWapps,
  syncMentionSeen,
  syncInvitationInfo,
  syncRoomsLastMessages,
  callService.checkForIncomingCalls,
  syncStoryRibbons,
  syncUserProfile,
  syncAds,
]
